import L from "leaflet";
import React from "react";
import { useMapEvents } from "react-leaflet";
import { Button, IconButton } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DirectionsOutlinedIcon from "@mui/icons-material/DirectionsOutlined";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

const ControlClasses = {
  bottomleft: "leaflet-bottom leaflet-left",
  bottomright: "leaflet-bottom leaflet-right",
  topleft: "leaflet-top leaflet-left",
  topright: "leaflet-top leaflet-right",
};

const LeafletGetDirections = ({
  btnPosition,
  sourceLat,
  sourceLng,
  destLat,
  destLng,
  zoom,
  t,
}) => {
  const divRef = React.useRef(null);
  const ZOOM = zoom ? zoom : "14";

  const btnTitle = t("direction");

  React.useEffect(() => {
    if (divRef.current) {
      L.DomEvent.disableClickPropagation(divRef.current);
      L.DomEvent.disableScrollPropagation(divRef.current);
    }
  }, []);

  const handleClick = React.useCallback((destVLat, destVLng) => {
    window.open(
      "https://www.google.com/maps/dir/" +
        sourceLat +
        "," +
        sourceLng +
        "/" +
        destVLat +
        "," +
        destVLng +
        "/" +
        "@" +
        sourceLat +
        "," +
        sourceLng +
        "," +
        ZOOM +
        "z"
    );
  }, []);

  return (
    <div ref={divRef} className={btnPosition && ControlClasses[btnPosition]}>
      <div
        className={"leaflet-control leaflet-bar leaflet-control-zoom"}
        style={{ left: "110px" }}
      >
        <Box>
          <BootstrapTooltip
            title={
              <Typography varinat="subtitle2" sx={{ p: 1 }}>
                {btnTitle}
              </Typography>
            }
            sx={{ p: 1 }}
          >
            <Button
              size="small"
              sx={{
                backgroundColor: "#fff",
                color: "black",
                borderRadius: 0,
                "&:hover": { backgroundColor: "#e9e9e9" },
                fontWeight: 600,
                borderRadius:"4px"
              }}
              onClick={() => handleClick(destLat, destLng)}
              endIcon={<DirectionsOutlinedIcon />}
            >
              {btnTitle}
            </Button>
          </BootstrapTooltip>
        </Box>
      </div>
    </div>
  );
};

export default LeafletGetDirections;
